const IS_TOUCH = 'is-touch';
const WITH_MOUSE = `${IS_TOUCH}--with-mouse`;
const html = document.documentElement;

class DetectTouch {
    touch: boolean;
    hasMouse: boolean;

    get isTouchDevice() {
        return this.touch;
    }

    constructor() {
        this.hasMouse = false;
        this.touch = 'ontouchstart' in html || navigator.maxTouchPoints > 0;

        html.addEventListener('touchstart', () => {
            html.removeEventListener('mousemove', () => this.handleMouseEvent());
        });

        html.addEventListener('mousemove', () => this.handleMouseEvent());

        if (this.touch) {
            html.classList.add(IS_TOUCH);
        }
    }

    handleMouseEvent() {
        if (!this.hasMouse && html.classList.contains(IS_TOUCH)) {
            html.classList.add(WITH_MOUSE);
            this.hasMouse = true;
        }
    }
}

export default new DetectTouch();
